import { render, staticRenderFns } from "./OnlyForTeacherIndicator.vue?vue&type=template&id=1bfb3f7b&scoped=true&"
import script from "./OnlyForTeacherIndicator.vue?vue&type=script&lang=ts&"
export * from "./OnlyForTeacherIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./OnlyForTeacherIndicator.vue?vue&type=style&index=0&id=1bfb3f7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfb3f7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
